"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class CreateReport extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'createReport';
        this._all = initParams.all;
        this._testing = initParams.testing;
    }
    set all(value) {
        console.error('Do not set objects this way');
    }
    get all() {
        return this._all;
    }
    set testing(value) {
        console.error('Do not set objects this way');
    }
    get testing() {
        return this._testing;
    }
}
exports.default = CreateReport;
//# sourceMappingURL=createReport.js.map